import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { useConfig } from 'src/app/shared/hooks/useConfig';
import { log } from 'src/app/utils/logging';
import { dispatchJobLocationActions } from 'src/app/v1/state/dispatcher/jobLocation';
import { GET_LOCATION } from 'src/graphql/location';
import type { AppState } from 'src/types/appState';

export const useJobLocation = () => {
  const { isDataCleanupComplete, jobLocationId, hirerNation } = useSelector(
    (state: AppState) => ({
      isDataCleanupComplete: state.app.isDataCleanupComplete,
      jobLocationId: state.formData.jobLocationId,
      hirerNation: state.session.hirerAccount.nation,
    }),
    shallowEqual,
  );
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { getLanguage } = useConfig();

  useQuery(GET_LOCATION, {
    errorPolicy: 'all',
    skip: !(isDataCleanupComplete && jobLocationId),
    variables: {
      locationId: jobLocationId,
      contextualCountry: hirerNation,
      language: getLanguage(),
    },
    onCompleted(data) {
      dispatchJobLocationActions(dispatch, data?.location);
      setIsLoading(false);
    },
    onError(error) {
      log.error('useJobLocation | getLocation', {
        error,
        jobLocationId,
        isDataCleanupComplete,
      });
      setIsLoading(false);
    },
  });

  return { loading: isLoading };
};
